<template>
  <div class="container">
  </div>
</template>

<script>

export default {
  name: "SingleCourse",
}
</script>

<style scoped>

</style>